<footer class="footer pt-120">
  <div class="container">
    <h1>Contacto:</h1>
    <div class="row">
      <!-- Columna 1: Información de contacto -->
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <div class="footer-widget">
          <div class="logo">
            <img width="150" src="https://cdn.buttercms.com/PBral0NQGmmFzV0uG7Q6" alt="logo" loading="lazy">
          </div>
          <ul class="contact-info">
            <li><i class="lni lni-whatsapp"></i> Whatsapp +54 9 11 1234-5678</li>
            <li><i class="lni lni-envelope"></i> olasverdes&#64;gmail.com</li>
            <li><i class="lni lni-map-marker"></i> Zona Sur, Buenos Aires - Argentina</li>
            <li><i class="lni lni-timer"></i> 10:00 a 19:00hs</li>
          </ul>
        </div>
      </div>

      <!-- Columna 2: Redes sociales -->
      <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">
        <div class="footer-widget">
          <h3>Seguímos</h3>
          <ul class="social-links">
            <li class="pointer"><i class="lni lni-instagram"></i> &#64;olasverdes.ong </li>
            <li class="pointer"><i class="lni lni-facebook my-2"></i>  &#64;olasverdes.facebook</li>
            <li class="pointer"><i class="lni lni-linkedin"></i> &#64;olasverdes.lni-linkedin</li>
            <li class="pointer"><i class="lni lni-twitter mt-2"></i> &#64;olasverdes.twitter</li>
          </ul>
        </div>
      </div>

      <!-- Columna 3: Sitemap -->
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12">
        <div class="footer-widget">
          <h3>Mapa sitio</h3>
          <ul class="links">
            <li><a href="#">Nosotros</a></li>
            <li><a href="#">El Club</a></li>
            <li><a href="#">Marco Legal</a></li>
            <li><a href="#">Ser Parte</a></li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Línea de separación y derechos de autor -->
    <div class="row">
      <div class="col-12 text-center mt-4">
        <hr />
        <p>COPYRIGHT © 2024 – ASOCIACION CANNABICA OLAS VERDES TODOS LOS DERECHOS RESERVADOS</p>
        <p>Software Design by Mosquera & Assoc. 🔥</p>
      </div>
    </div>
  </div>
</footer>

<app-scroll-top></app-scroll-top>
